import { render, staticRenderFns } from "./PxHistoricoPrecoProduto.vue?vue&type=template&id=2a929b9e&scoped=true&"
import script from "./PxHistoricoPrecoProduto.vue?vue&type=script&lang=js&"
export * from "./PxHistoricoPrecoProduto.vue?vue&type=script&lang=js&"
import style0 from "./PxHistoricoPrecoProduto.vue?vue&type=style&index=0&id=2a929b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a929b9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VMenu,VTooltip})
